module.exports = __webpack_public_path__ + "static/media/header-4.4d83bad8.jpg";